export const GET_LEADOM_WEB_JOBS_REQUEST = 'GET_LEADOM_WEB_JOBS_REQUEST';
export const GET_LEADOM_WEB_JOBS_REQUEST_SUCCESS = 'GET_LEADOM_WEB_JOBS_REQUEST_SUCCESS';
export const GET_LEADOM_WEB_JOBS_REQUEST_FAILURE = 'GET_LEADOM_WEB_JOBS_REQUEST_FAILURE';
export const SET_LEADOM_FILTER_WEB_JOBS = 'SET_LEADOM_FILTER_WEB_JOBS';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic/redux/constants/web_jobs.constants.js